export const ProjectStatusEnum = {
  PendingApproval : 1,
  OnGoing : 2,
  PendingVolunteerAssigment : 3,
  Completed : 4,
  Canceled : 5,
  };
  